import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'

/** Demande d'aide (#81) : l'API choisit le destinataire selon le rôle de l'expéditeur. */
export const GQL_SEND_CONTACT_REQUEST = typedGql('mutation')({
  sendContactRequest: [{ input: $('input', 'ContactRequestInput!') }, true],
})
